module.exports = __webpack_public_path__ + "img/vhr_planet_demobild_small.4c34c6c5.png";